import * as React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

function LoadingOverlay() {
  return (
    <Backdrop
      open
      sx={{
        opacity: 0,
        backgroundColor: 'transparent',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <CircularProgress />
    </Backdrop>
  );
}

export default LoadingOverlay;
